// <s-qty-limit data-max="N"> wraps a <s-quantity-selector>. When the shopper tries to go above N
// (the variant's available stock), the quantity snaps back to N and the [data-qty-limit] note shows.
// Rendered only for stock-tracked variants that can't oversell; untracked/pre-order items get no limit.
class SQtyLimit extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const { signal } = this.#ac;
    this.input = this.querySelector('input[type="number"]');
    this.note = this.querySelector("[data-qty-limit]");
    if (!this.input || !this.note) return;

    this.addEventListener("s-quantity:change", () => this.#check(), { signal });
    this.input.addEventListener("change", () => queueMicrotask(() => this.#check()), { signal });
    this.input.addEventListener("input", () => this.#check(true), { signal });
    this.#check();
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  get #max() {
    const v = parseInt(this.dataset.max, 10);
    return isNaN(v) ? Infinity : v;
  }

  #check(typing = false) {
    const max = this.#max;
    const value = parseInt(this.input.value, 10);
    if (isNaN(value)) return;
    if (value > max) {
      if (!typing) this.input.value = String(max);
      this.note.hidden = false;
    } else if (value < max) {
      this.note.hidden = true;
    }
  }
}

if (!customElements.get("s-qty-limit")) customElements.define("s-qty-limit", SQtyLimit);
